'use client';
import { factory, useWindowSize, Box, Grid, Typography, Flex, omitText } from '@kohler-dsm-library/kohler-core';
import { CloseIcon, ArrowLeftIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import classes from './LoginMenu.module.css.mjs';

const LoginMenu = factory((props, ref) => {
  const {
    className,
    headingSignIn,
    headingSignOut,
    loggedInCTAs,
    loggedOutCTAs,
    signOutCTA,
    isLoggedIn,
    setIsOpenMobileMenu,
    setMenuType,
    ...rest
  } = props;
  const classNames = clsx(className, "kohler-login-menu-root", classes.loginMenu);
  const { width } = useWindowSize();
  const isSmallerScreen = width < 1024;
  return /* @__PURE__ */ React.createElement(Box, { id: "login-menu", component: "div", ref, className: classNames, ...rest }, /* @__PURE__ */ React.createElement(Grid, { className: clsx("center-grid", classes.loginMenuGridGap) }, /* @__PURE__ */ React.createElement(Box, { className: classes.loginMenuMobileClose }, /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      onClick: () => {
        setMenuType?.(null);
        if (setIsOpenMobileMenu) {
          setIsOpenMobileMenu(false);
        }
      },
      className: classes.loginMenuMobileCloseIcon
    },
    /* @__PURE__ */ React.createElement(CloseIcon, { withBoundingBox: false, size: "medium" })
  ), /* @__PURE__ */ React.createElement(
    Typography,
    {
      size: "label-regular-m",
      component: "button",
      type: "button",
      textColor: "var(--content-secondary)",
      className: classes.loginMenuMobileBackText,
      onClick: () => setMenuType?.(null)
    },
    /* @__PURE__ */ React.createElement(ArrowLeftIcon, { withBoundingBox: false, size: "small" }),
    " Menu"
  )), /* @__PURE__ */ React.createElement(Flex, { className: classes.loginMenuContent }, isLoggedIn && headingSignIn && /* @__PURE__ */ React.createElement(Typography, { size: "navigation-overlay-title", textColor: "var(--content-primary)" }, headingSignIn.text), !isLoggedIn && headingSignOut && /* @__PURE__ */ React.createElement(Typography, { size: "navigation-overlay-title", textColor: "var(--content-primary)" }, headingSignOut.text)), (loggedInCTAs || loggedOutCTAs) && /* @__PURE__ */ React.createElement("ul", { className: classes.loginMenuContentList }, isLoggedIn && loggedInCTAs && loggedInCTAs.map((CTA) => {
    return /* @__PURE__ */ React.createElement("li", { key: CTA.text }, /* @__PURE__ */ React.createElement(
      Typography,
      {
        component: "href" in CTA && CTA?.href ? CTA.component ?? "a" : CTA.component ?? "button",
        ...omitText(CTA),
        size: isSmallerScreen ? "navigation-overlay-item-l" : "h6",
        textColor: "var(--content-action-default)"
      },
      CTA.text
    ));
  }), !isLoggedIn && loggedOutCTAs && loggedOutCTAs.map((CTA) => {
    return /* @__PURE__ */ React.createElement("li", { key: CTA.text }, /* @__PURE__ */ React.createElement(
      Typography,
      {
        component: "href" in CTA && CTA?.href ? CTA.component ?? "a" : CTA.component ?? "button",
        ...omitText(CTA),
        size: isSmallerScreen ? "navigation-overlay-item-l" : "h6",
        textColor: "var(--content-action-default)"
      },
      CTA.text
    ));
  }), isLoggedIn && signOutCTA && /* @__PURE__ */ React.createElement("li", { className: classes.loginMenuContentListLastItem }, /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: "href" in signOutCTA && signOutCTA?.href ? signOutCTA.component ?? "a" : signOutCTA.component ?? "button",
      ...omitText(signOutCTA),
      size: isSmallerScreen ? "label-regular-l" : "label-regular-m",
      textColor: "var(--content-action-default)"
    },
    signOutCTA.text || "Sign Out"
  )))));
});

export { LoginMenu };
